import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, HostListener, inject, Input, Output, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-id-drop-down',
  templateUrl: './customer-id-drop-down.component.html',
  styleUrls: ['./customer-id-drop-down.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CustomerIdDropDownComponent {
  screenWidth: number;
  widthPercentage = 67;
  isMobile: boolean = false;
  selected: boolean[] = [false];
  searchInput;
  sub = new Subscription();
  @Output() childValue = new EventEmitter<any>();
  selectedOption: any = '';
  @Input() customerId;
  @Output() dataEvent = new EventEmitter<any>();
  @Input() pageSource: string;
  platformId = inject(PLATFORM_ID);
  constructor(private breakpointObserver: BreakpointObserver) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.widthPercentage = 87;
        }
      })
    );
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
      this.setCustomWidth();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
      this.setCustomWidth();
    }
  }

  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = (this.screenWidth * this.widthPercentage) / 100;
      document.documentElement.style.setProperty('--custom-width', `${widthInPixels}px`);
    }
  }
  selectedIds(data, currentData, i) {
    if (this.pageSource == 'myOwnPartNumbers') {
      const clonedCopy = data;
      clonedCopy.map((item) => {
        if (item.uid == currentData.uid) {
          item.selected = this.selected[i];
        }
      });
      this.childValue.emit(clonedCopy);
    } else if (this.pageSource == 'warrantyClaim' || this.pageSource == 'users') {
      this.childValue.emit(currentData);
      this.dataEvent.emit(currentData.uid);
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.sub.unsubscribe();
  }

}
